<aside class="control-sidebar control-sidebar-dark capa-sidebar" id="sidebar-account">
  <ul class="nav nav-tabs nav-justified control-sidebar-tabs" style="background-color: #6682b2;">
    <li class="sidebar-tabs active">
      <a href="#control-sidebar-user-tab" data-toggle="tab" aria-expanded="true"><span i18n="@@myAccount">My account </span><em class="fa fa-user" style="margin-left: 5px"></em></a>
    </li>
    <li class="sidebar-tabs">
      <a href="#control-sidebar-install-tab" data-toggle="tab" aria-expanded="true"><span i18n="@@addLicense">Add license</span> <em class="fa fa-plus" style="margin-left: 5px"></em></a>
    </li>
  </ul>

  <div class="tab-content">
    <div class="tab-pane active" id="control-sidebar-user-tab">
      <h2 i18n="@@myAccount">My account</h2>
      <form [formGroup]="AccountForm" (ngSubmit)="onSubmitProfile()">

        <!---------------------------------------------- FIRSTNAME ------------------------------------------->
        <div class="form-group" [ngClass]="firstName.invalid && (firstName.dirty || firstName.touched) ? 'has-error' : ''">
          <label for="firstName" i18n="@@firstname">Firstname *</label>
          <input id="firstName" (keyup)="canValidateForm = true" type="text" formControlName="firstName" class="form-control" i18n-placeholder placeholder="Firstname">
          <span class="help-block" *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" i18n="@@fieldCannotBeEmpty">This field cannot be empty.</span>
        </div>

        <!---------------------------------------------- LASTNAME ------------------------------------------->
        <div class="form-group" [ngClass]="lastName.invalid && (lastName.dirty || lastName.touched) ? 'has-error' : ''">
          <label for="lastName" i18n="@@lastname">Lastname *</label>
          <input id="lastName" (keyup)="canValidateForm = true" type="text" formControlName="lastName" class="form-control" i18n-placeholder placeholder="Lastname">
          <span class="help-block" *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" i18n="@@fieldCannotBeEmpty">This field cannot be empty.</span>
        </div>

        <!---------------------------------------------- LANGUAGE ------------------------------------------->
        <div class="form-group">
          <label for="langage" i18n="@@langage">Langage *</label>
          <select id="langage" class="form-control" (change)="selectLangByMenu($event)">
            <option value="5" i18n="@@french">French</option>
            <option value="3" i18n="@@english">English</option>
            <option value="1" i18n="@@german">German</option>
          </select>
        </div>

        <!---------------------------------------------- EMAIL ------------------------------------------->
        <div class="form-group" [ngClass]="email.invalid && (email.dirty || email.touched) ? 'has-error' : ''">
          <label for="email" i18n="@@email">Email *</label>
          <input id="email" (keyup)="canValidateForm = true" type="email" formControlName="email" class="form-control" i18n-placeholder placeholder="exemple@cotral.com">
          <span class="help-block" *ngIf="email.invalid && (email.dirty || email.touched)" i18n="@@enterValidEmail">Please enter a valid email address (ex: exemple@cotral.com)</span>
        </div>

        <!---------------------------------------------- PASSWORD ------------------------------------------->
        <div class="form-group" [ngClass]="password.invalid && (password.dirty || password.touched) ? 'has-error' : ''">
          <label class="control-label" for="password" i18n="@@password">Password</label>
          <input id="password" (keyup)="canValidateForm = true" type="password" class="form-control" formControlName="password" i18n-placeholder placeholder="Password">
          <span class="help-block" *ngIf="password.invalid && (password.dirty || password.touched)" i18n="@@passwordRegex">The password must contain at least 8 characters and one number.</span>
        </div>

        <!---------------------------------------------- CONFIRM PASSWORD ---------------------------------->
        <div class="form-group" [ngClass]="(confirmPassword.invalid || confirmPassword.value != password.value) && (confirmPassword.dirty || confirmPassword.touched) ? 'has-error' : ''">
          <label class="control-label" for="confirmPassword" i18n="@@passwordConfirmation">Password confirmation</label>
          <input id="confirmPassword" (keyup)="canValidateForm = true" type="password" class="form-control" formControlName="confirmPassword" i18n-placeholder placeholder="Password confirmation">
          <span class="help-block" *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)" i18n="@@passwordRegex">The password must contain at least 8 characters and one number.</span>
          <span class="help-block" *ngIf="confirmPassword.value != password.value && (confirmPassword.dirty && confirmPassword.touched)" i18n="@@passwordsNotIdentical">The passwords are not identical.</span>
        </div>

        <!---------------------------------------------- PHONE ------------------------------------------->
        <label for="phone" i18n="@@phone">Phone</label>
        <input id="phone" type="text" formControlName="phone" class="form-control" i18n-placeholder placeholder="Phone">

        <br />

        <button type="submit" class="btn btn-primary btn-block btn-flat" [disabled]="!canValidateForm || !AccountForm.valid || confirmPassword.value != password.value" i18n="@@validate">VALIDATE</button>
      </form>

      <h2 class="pull-left" i18n="@@myLicenses">My licenses</h2>
      <br>
      <br>
      <br>
      <div *ngIf="(licenseList$ | async)?.length > 0">
        <hr>
        <div *ngFor="let currentLicense of licenseList$ | async">
          <h4>{{ currentLicense.idInstall }}</h4>
          <p>{{  currentLicense.nom }}</p>
          <hr>
        </div>
      </div>

      <div *ngIf="(licenseList$ | async)?.length == 0">
        <h4 style="margin: 0; font-size: 24px; font-family: 'Source Sans Pro', Sans-Serif;" i18n="@@noLicense">No license</h4>
      </div>

      <button class="btn btn-danger btn-block" (click)="logout()"><span i18n="@@disconnect">DISCONNECT</span><span class="fa fa-power-off" style="margin-left: 5px"></span></button>
    </div>

    <div class="tab-pane" id="control-sidebar-install-tab">
      <h2 i18n="@@addLicense">Add a license</h2>
      <form [formGroup]="InstallForm" (ngSubmit)="onSubmitInstall()">
        <div class="form-group" [ngClass]="idInstall.invalid && (idInstall.dirty || idInstall.touched) ? 'has-error' : ''">
          <label for="idInstall" i18n="@@licenseKey">License key</label>
          <input id="idInstall" class="form-control" type="text" formControlName="idInstall" i18n-placeholder placeholder="License key">
          <span class="help-block" *ngIf="idInstall.invalid && (idInstall.dirty || idInstall.touched)" i18n="@@invalidKeyFormat">Invalid key format</span>
        </div>
        <button type="submit" class="btn btn-primary btn-block" [disabled]="!InstallForm.valid" i18n="@@validate">Validate</button>
      </form>

      <div *ngIf="ErrorInstallManagement == true" style="margin-top: 16px" class="alert alert-danger">
        <h4 i18n="@@error">ERROR</h4>
        <p i18n="@@ErrorInstallManagement">Impossible operation: This license does not exist or an account is already linked to it.</p>
      </div>

      <div *ngIf="SuccessInstallManagement == true" style="margin-top: 16px" class="alert alert-success alert-dismissible">
        <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
        <h4 i18n="@@success">SUCCESS</h4>
        <p i18n="@@SuccessInstallManagement">This license has been added to your account.</p>
      </div>
    </div>
  </div>
</aside>
